import { render, staticRenderFns } from "./messageDrawer.vue?vue&type=template&id=68f676c0&scoped=true"
import script from "./messageDrawer.vue?vue&type=script&lang=js"
export * from "./messageDrawer.vue?vue&type=script&lang=js"
import style0 from "./messageDrawer.vue?vue&type=style&index=0&id=68f676c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f676c0",
  null
  
)

export default component.exports